module.exports = __webpack_public_path__ + "img/9.12fee11f.jpg";